import { useNavigate } from 'react-router-dom';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

export function useSchoolGoTo() {
  const navigate = useNavigate();
  const { school, schoolyear } = useSchoolSchoolyear();
  return (path: string) =>
    navigate(`/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${path}`);
}

export function useSchoolRelativePath() {
  const { school, schoolyear } = useSchoolSchoolyear();
  return {
    schoolRelativePath: (path: string) =>
      `/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${path}`,
  };
}
